module.exports = __webpack_public_path__ + "static/media/400379_02.03cde80b.png";